exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".download-toast-footer-box{margin-top:17px;display:flex;justify-content:flex-end}\n", ""]);

